import { useMemo } from "react";
import { Link, useNavigate } from "react-router";

import { Typography, useMediaQuery } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import TilleyDataGrid from "components/shared/DataGrid/TilleyDataGrid";
import { formatNumber } from "utility/formatters";

import { NavigateIcon } from "../../../Icons/Icons";

export default function FarmCountyDataTable({
  currentCards,
  isLoading,
  crop_year = "potential",
  pageSizes = [5, 10, 25, 50, 100],
  rowHeight = 80,
}) {
  const navigate = useNavigate();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("lg"), { noSsr: true });

  const columns = useMemo(
    () => [
      {
        field: "location_county_name",
        headerName: "Name",
        flex: 1.5,
        renderCell: (params) => (
          <Typography
            color="primary"
            component={Link}
            to={`/vault/${crop_year}/${params.row.location_state_name}/${params.row.location_county_name}`}
          >
            {params.row.location_county_name}, {params.row.location_state_name}
          </Typography>
        ),
      },
      {
        field: "reported_acreage",
        headerName: "Acres",
        flex: 1,
        renderCell: (params) => {
          return formatNumber(params.row.reported_acreage, 0);
        },
      },
      {
        field: "base_acreage",
        headerName: "Base Acres",
        flex: 1,
        renderCell: (params) => {
          return formatNumber(params.row.base_acreage, 0);
        },
      },
      {
        field: "unit_count",
        headerName: "Farms",
        flex: 1,
        renderCell: (params) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {formatNumber(params.row.unit_count, 0) + " farm" + (Number(params.row.unit_count) === 1 ? "" : "s")}
            </span>
          );
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        headerAlign: "right",
        align: "right",
        width: 150,
        sortable: false,
        getActions: (params) => {
          return [
            <GridActionsCellItem
              key="view"
              icon={<NavigateIcon />}
              label="View Details"
              data-testid={`Open Budget ${params.row.name}`}
              onClick={() =>
                navigate(`/vault/${crop_year}/${params.row.location_state_name}/${params.row.location_county_name}`)
              }
            />,
          ];
        },
        flex: 0,
      },
    ],
    [navigate, formatNumber]
  );

  return (
    <TilleyDataGrid
      rows={currentCards || []}
      columns={columns}
      pageSizeOptions={pageSizes}
      defaultPageSize={isMobile ? 5 : 10}
      gridKey="farm-county"
      getRowId={(row) => row.uuid}
      rowHeight={rowHeight}
      isLoading={isLoading}
      sx={{ width: "99%", boxSizing: "border-box" }}
    />
  );
}
